"use client";

import { ArrowRight, MapPin, Navigation } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Location() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const locations = [{
    city: "STUTTGART",
    code: "STR"
  }, {
    city: "MÜNCHEN",
    code: "MUC"
  }, {
    city: "BERLIN",
    code: "BER"
  }];
  return <section data-section-id="2848" id="hier-finden-sie-uns" className="bg-background text-foreground py-24 md:py-32 lg:py-40 px-6 md:px-10 lg:px-16">
      <div className="max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          {}
          <div ref={leftRef} className={`lg:col-span-5 flex flex-col transition-all duration-1000 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            {}
            <div className="flex items-center gap-3 mb-10">
              <span className="h-px w-8 bg-primary" />
              <span className="font-mono text-xs tracking-[0.25em] uppercase text-muted-foreground">
                Standorte
              </span>
            </div>

            {}
            <h2 className="font-default font-light text-4xl md:text-5xl lg:text-[56px] leading-[1.05] tracking-tight mb-8">
              Besuchen Sie unser{" "}
              <span className="italic font-light text-primary">
                Kompetenzzentrum
              </span>
              .
            </h2>

            {}
            <p className="font-default text-lg md:text-xl leading-relaxed text-muted-foreground mb-12 max-w-xl">
              Erleben Sie die unsichtbare Klimatisierung hautnah. In unseren Showrooms zeigen wir Ihnen, wie Ducted AC Systeme Ihr Zuhause flüsterleise kühlen und heizen – ohne störende Geräte an der Wand.
            </p>

            {}
            <div className="space-y-0 mb-12">
              {}
              <div className="py-6 border-t border-border">
                <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-muted-foreground mb-3">
                  Adresse
                </div>
                <address className="font-default not-italic text-lg md:text-xl text-foreground leading-relaxed">
                  Bachstr. 33
                  <br />
                  73630 Remshalden
                </address>
              </div>

              {}
              <div className="py-6 border-t border-border">
                <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-muted-foreground mb-3">
                  Öffnungszeiten
                </div>
                <div className="font-mono text-sm tracking-[0.15em] uppercase text-foreground leading-relaxed">
                  Montag — Samstag
                  <br />
                  8:30 — 18 Uhr
                </div>
              </div>

              {}
              <div className="py-6 border-t border-b border-border">
                <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-muted-foreground mb-3">
                  Kontakt
                </div>
                <div className="font-default text-lg md:text-xl text-foreground space-y-1">
                  <Link to="tel:07111234567" className="block hover:text-primary transition-colors duration-300">
                    0711 123 4567
                  </Link>
                  <Link to="mailto:info@naber-conduct.com" className="block hover:text-primary transition-colors duration-300">
                    info@naber-conduct.com
                  </Link>
                </div>
              </div>
            </div>

            {}
            <div className="flex flex-col sm:flex-row gap-4">
              <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-md h-12 px-8 font-mono text-xs tracking-[0.2em] uppercase shadow-md">
                <Link to="/ContactPage">
                  Termin vereinbaren
                  <ArrowRight className="ml-1 h-4 w-4" />
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="bg-transparent border border-border text-foreground hover:bg-accent hover:text-accent-foreground rounded-md h-12 px-8 font-mono text-xs tracking-[0.2em] uppercase">
                <Link to="https://maps.google.com/?q=Klimaweg+1+70173+Stuttgart" newTab>
                  <Navigation className="mr-1 h-4 w-4" />
                  Anfahrt planen
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={rightRef} className={`lg:col-span-7 transition-all duration-1000 ease-out delay-150 ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            {}
            <div className="relative w-full border border-border overflow-hidden bg-card">
              <div className="relative w-full" style={{
              paddingBottom: "125%"
            }}>
                {}
                <div className="absolute inset-0 bg-gradient-to-br from-card via-background to-card">
                  {}
                  <svg className="absolute inset-0 w-full h-full opacity-30" viewBox="0 0 400 500" preserveAspectRatio="xMidYMid slice" fill="none">
                    {}
                    <line x1="0" y1="80" x2="400" y2="80" stroke="var(--border)" strokeWidth="0.5" />
                    <line x1="0" y1="160" x2="400" y2="160" stroke="var(--border)" strokeWidth="0.5" />
                    <line x1="0" y1="240" x2="400" y2="240" stroke="var(--border)" strokeWidth="1" />
                    <line x1="0" y1="320" x2="400" y2="320" stroke="var(--border)" strokeWidth="0.5" />
                    <line x1="0" y1="400" x2="400" y2="400" stroke="var(--border)" strokeWidth="0.5" />

                    {}
                    <line x1="60" y1="0" x2="60" y2="500" stroke="var(--border)" strokeWidth="0.5" />
                    <line x1="140" y1="0" x2="140" y2="500" stroke="var(--border)" strokeWidth="0.5" />
                    <line x1="220" y1="0" x2="220" y2="500" stroke="var(--border)" strokeWidth="1" />
                    <line x1="300" y1="0" x2="300" y2="500" stroke="var(--border)" strokeWidth="0.5" />
                    <line x1="360" y1="0" x2="360" y2="500" stroke="var(--border)" strokeWidth="0.5" />

                    {}
                    <line x1="0" y1="350" x2="400" y2="180" stroke="var(--muted-foreground)" strokeWidth="1.2" opacity="0.6" />

                    {}
                    <rect x="80" y="100" width="40" height="50" fill="var(--accent)" opacity="0.15" />
                    <rect x="160" y="180" width="40" height="40" fill="var(--accent)" opacity="0.15" />
                    <rect x="240" y="260" width="40" height="50" fill="var(--accent)" opacity="0.15" />
                    <rect x="80" y="340" width="40" height="50" fill="var(--accent)" opacity="0.15" />
                    <rect x="320" y="100" width="30" height="50" fill="var(--accent)" opacity="0.15" />
                    <rect x="240" y="420" width="50" height="40" fill="var(--accent)" opacity="0.15" />
                  </svg>

                  {}
                  <div className="absolute inset-0 bg-gradient-radial from-transparent via-transparent to-background/60" />

                  {}
                  <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                    {}
                    <span className="absolute inset-0 -m-6 rounded-lg border border-primary/40 animate-ping" />
                    <span className="absolute inset-0 -m-3 rounded-lg bg-primary/20 animate-pulse" style={{
                    animationDuration: "2.5s"
                  }} />
                    {}
                    <div className="relative flex items-center justify-center w-10 h-10 rounded-lg bg-primary shadow-lg">
                      <MapPin className="h-5 w-5 text-primary-foreground" strokeWidth={2} />
                    </div>
                  </div>

                  {}
                  <div className="absolute bottom-6 left-6 right-6 flex items-end justify-between gap-4">
                    <div>
                      <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-muted-foreground mb-1">
                        Hauptsitz
                      </div>
                      <div className="font-default text-xl md:text-2xl text-foreground">
                        Stuttgart
                      </div>
                    </div>
                    <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-muted-foreground text-right">
                      48.7758° N
                      <br />
                      9.1829° E
                    </div>
                  </div>

                  {}
                  <div className="absolute top-4 left-4 w-4 h-4 border-l border-t border-primary/60" />
                  <div className="absolute top-4 right-4 w-4 h-4 border-r border-t border-primary/60" />
                  <div className="absolute bottom-4 left-4 w-4 h-4 border-l border-b border-primary/60" />
                  <div className="absolute bottom-4 right-4 w-4 h-4 border-r border-b border-primary/60" />
                </div>
              </div>
            </div>

            {}
            <div className="mt-8">
              <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-muted-foreground mb-4">
                Weitere Beratungszentren
              </div>
              <div className="flex flex-wrap items-center gap-3">
                {locations.map((loc, i) => <Link key={loc.code} to="#" data-index={i} className="group inline-flex items-center gap-2 px-4 py-2.5 border border-border hover:border-primary transition-colors duration-300">
                    <span className="h-1.5 w-1.5 rounded-lg bg-muted-foreground group-hover:bg-primary transition-colors duration-300" />
                    <span className="font-mono text-xs tracking-[0.2em] uppercase text-foreground group-hover:text-primary transition-colors duration-300">
                      {loc.city}
                    </span>
                  </Link>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}